/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

// Uploadery by ShopPad - Shorten Link
Handlebars.registerHelper('shortenUploaderyLink', function(options) { 
  if(options.indexOf('//uploadery.s3') !== -1 ){
    return  new Handlebars.SafeString("<a href=" + options + ">" + "Link to your file" + "</a>");
  }
  else {
    return  new Handlebars.SafeString(options);
  }
});

// Infinite Options by ShopPad - Hide Product Bundle Data
Handlebars.registerHelper("ifDoesNotContain", function(string, substring, options) {
  return (string.indexOf(substring) < 0) ? options.fn(this) : "";
});
$(document).ready(function() {
    
    $(".js-product-single-box").trigger("detach.ScrollToFixed");
  
  	// show notes on click
    $('#show-notes').on('click', function() {
        $('.cart__message').show();
    });
  
});

/** Unique tabs using H6 as an anchor **/
$($('.product-single__content-text').find('h6').get().reverse()).each(function(i) {
  	
  	var tabName = $(this).text();
  	tabContent = '';
  	
  	//check if h6 has text inside
 	if ($(this).text() != '') {
      	
      	//hide h6
    	$(this).hide();
  
      	//combine content between H6 elements
        $(this).nextUntil('h6').each(function() {
            tabContent = tabContent + this.outerHTML;
          	
          	//hide content
            $(this).hide();
        });
		
      	//generate tab HTML
      	$('.js-accordion').prepend('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-accordion-info" style="display: none;"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
        $('.js-accordion').prepend('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-accordion-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></a>');

    } else {	

      	//hide empty H6
      	$(this).hide();
    }
});

